import { Task } from './task';

type QueueCallback = (task: Task) => void;

interface Options {
  targetFps: number;
}

export class Loop {
  public readonly options: Options;
  private readonly tasks: Task[] = [];
  private readonly frameLength: number;
  private nextTick: number;

  public constructor(options: Options) {
    this.options = options;
    this.frameLength = 1000 / options.targetFps;
    this.nextTick = performance.now();
  }

  public queue(callback: QueueCallback) {
    const task = new Task();
    callback(task);
    this.tasks.push(task);
  }

  public run() {
    window.requestAnimationFrame(() => this.run());

    const nowTick = performance.now();
    if (nowTick > this.nextTick) {
      const deltaTick = nowTick - this.nextTick;
      const deltaFrame = Math.floor(deltaTick / this.frameLength);

      for (let i = 0; i < deltaFrame; i++) {
        this.tasks.forEach(task => task.beginUpdate());
        this.nextTick += this.frameLength;
      }

      this.tasks.forEach(task => task.beginDraw());
    }
  }
}
